// TODO(ui-foundation): promote this component to ui-foundation and remove from this repo.
import type { ReactNode } from "react";

export type AuthHeadingProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Heading level. Use "h1" when the card is the page's primary content. */
  as?: "h1" | "h2";
};

export function AuthHeading({ title, subtitle, as = "h2" }: AuthHeadingProps) {
  const Tag = as;
  return (
    <div className="events-auth-card__copy">
      <Tag className="font-display text-display text-brand">{title}</Tag>
      {subtitle ? (
        <p className="font-display text-subtitle text-ink-muted">{subtitle}</p>
      ) : null}
    </div>
  );
}
